<template lang="html">
  <div class="industryPage">
   <bannerTop :banners="$t('industry.banners')"/>
   <ul class="newslist">
     <li class="news" v-for="(item,key) in $t('industry.newslist')" :key="key">
       <div class="img" :style="{'background':'url('+item.imgUrl+')'}">
          <!-- <img :src="item.imgUrl" alt=""> -->
       </div>
       <div class="info">
         <p class="title">{{titleToUpperCase(item.title)}}</p>
         <p class="description" v-html="item.description"></p>
       </div>
     </li>
   </ul>
  </div>
</template>

<script>
import bannerTop from '@/components/bannerTop'
export default {
  name: 'industry',
  components:{
    bannerTop
  }
}
</script>

<style lang="less" src="../assets/css/industry.less"></style>
